import axios from 'axios';
import {getAuthHeader} from  '../global_helpers/authHeader.js';

const state = {
    siteAdmin: {
        wholesalerList: [],
    },
};

const getters = {
    getSiteAdmiWholesalerList: (state) => state.siteAdmin.wholesalerList,
};

const actions = {    
    async adminUpdateWholesaler({dispatch}, wholesaler){
        let authHeader = getAuthHeader();
        console.log("adminUpdateWholesaler")
        axios.put("/wholesaler/admin/", {wholesaler:wholesaler}, authHeader)
        .then(() => {
            dispatch('raiseMessage', `Successfully updated ${wholesaler.wholesaler_name}!`, {root: true});
            dispatch('adminGetWholesalerList');
        })
        .catch(err => {
           console.log(err);
           dispatch('raiseMessage', `There was an error updating ${wholesaler.wholesaler_name}!`, {root: true});
        });
    },

    async adminGetWholesalerList({commit, dispatch}){
        let authHeader = getAuthHeader();
        axios.get("/wholesaler/list/", authHeader)        
        .then((res) => {
            commit('adminSetWholesalerList', res.data);
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'There was an error loading the Provider list!', {root: true});
        });
    }
    
    // async adminCreateWholesaler({dispatch}, wholesaler){
    //     let authHeader = getAuthHeader();
    //     axios.post("/wholesaler/", {wholesaler:wholesaler}, authHeader)
    //     .then(() => {
    //         dispatch('raiseMessage', `Successfully created ${wholesaler.wholesaler_name}!`, {root: true});
    //         dispatch('adminGetWholesalerList');
    //     })
    //     .catch(err => {
    //        console.log(err);
    //        dispatch('raiseMessage', `There was an error creating ${wholesaler.wholesaler_name}!`, {root: true});
    //     });
    // },
};

const mutations = {
    adminSetWholesalerList(state, list){
        let exclude = ['Cash Balance Only','No Revenue Share']
        let filtered = list.filter(wholesaler => !exclude.includes(wholesaler.wholesaler_name))
        filtered.sort((a,b) => a.wholesaler_name.toLowerCase() > b.wholesaler_name.toLowerCase());
        state.siteAdmin.wholesalerList = filtered;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};